import { aboutData } from '@/mocks/about';

export default function Reputation() {
  return (
    <section className="py-10 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-14">
          {aboutData.stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 text-center"
            >
              <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className={`${stat.icon} text-lg text-primary-600`}></i>
              </div>
              <div className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="text-center mb-8">
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">
            我们的价值观
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            指导我们工作的核心理念
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {aboutData.values.map((val) => (
            <div
              key={val.title}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6"
            >
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                <i className={`${val.icon} text-lg text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                {val.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{val.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}